export default class Constants {
    static END_POINT = {
        LOGIN: "/login",
        PROFILE: "/profile",
        FORGET_PASSWORD: "/forget-password",
        UPDATE_PROFILE: "/update",
        RESET_PASSWORD: "/change-forget-password",
        UPLOAD_FILE: "/upload-files",
        CHANGE_PASSWORD: "/change-password",
        UPLOAD_SINGLE_FILE: "/file-upload",
        // Dashborad
        GET_USERS_COUNT: "/counts",

        // User tabs
        USERS: "/users",
        USER: "/user/",
        UPDATE_USER: "/update-user/",
        DELETE_USER: "/delete-user/",
        ENABLE_DISABLE_USER: "/active-inactive/",
        CATEGORY: "/category/",
        TRACKS: "/track/",
        PROGRAMS: "/program/",
        PLANS: "/plan/",
        AUTHORS: "/author/",
        FEEDBACKS: "/user-account-delete-reasons/",

        // Services
        SERVICES: "/service/",
        ADD_SERVICE: "/add-service",
        SERVICE_ITEM: "/service-item/",
        ADDITIONAL_SERVICE: "/additional-service/",
        ADD_ITEM: "/add-service-item/",
        ADD_ADDITIONAL_SERVICE: "/add-additional-service/",

        //Orders
        ORDERS: "/orders/",
        ORDER: "/order/",
        ORDER_STATUS: "/order-status/",

        //Style Guides
        STYLE_GUIDES: "/style/",
        ADD_STYLE_GUIDE: "/add-style",

        //Our Work
        OUR_WORK: "/our-work/",
        OUR_WORKS: "/our-works",

        //Product
        PRODUCT: "/product/",
        ADD_PRODUCT: "/add-product",

        //Content
        GET_TERMS_AND_CONDITIONS: "/term-and-condition",
        UPDATE_TERMS_AND_CONDITIONS: "/update-term-and-condition/",
        GET_PRIVACY_POLICY: "/privacy-policy",
        UPDATE_PRIVACY_POLICY: "/update-privacy-policy/",
        GET_FAQ: "/get-Faq",
        CREATE_FAQ: "/create-faq",
        UPDATE_FAQ: "/update-faq/",
        DELETE_FAQ: "/delete-faq/",

        //Contacts
        CONTACTS: "/contacts/",
        CONTACT: "/contact/",
        DELETE_CONTACT: "/delete-contact/",

        //Enquiries
        ENQUIRIES: "/enquires/",
        ENQUIRY: "/enquire/",

        //Our Clients
        OUR_CLIENT: "/our-client",
        OUR_CLIENTS: "/our-clients",

    };
}
